import React from "react";
import { FEATURES_DATA } from "../utils/constant";

const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2 style={{ marginTop: "110px" }}>Features</h2>
        </div>
        <div className="row">
          {FEATURES_DATA.Features.map((d, i) => (
            <div key={`${d.title}-${i}`} className="col-xs-6 col-md-3">
              <img src={d.icon} alt={d.title} />
              <h3>{d.title}</h3>
              <p>{d.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
